/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";

import { FragmentRefs } from "relay-runtime";
export type EventScreenPresentations_event = {
    readonly presentations: {
        readonly edges: ReadonlyArray<{
            readonly node: {
                readonly rowId: string;
                readonly prettyUrl: string;
                readonly title: string;
                readonly description: string | null;
                readonly presenterFirstName: string | null;
                readonly presenterLastName: string | null;
                readonly presenter: {
                    readonly firstName: string;
                    readonly lastName: string;
                    readonly " $fragmentRefs": FragmentRefs<"UserPrimaryPhotoNew_user">;
                } | null;
            };
            readonly cursor: string;
        }>;
    };
    readonly " $refType": "EventScreenPresentations_event";
};
export type EventScreenPresentations_event$data = EventScreenPresentations_event;
export type EventScreenPresentations_event$key = {
    readonly " $data"?: EventScreenPresentations_event$data | undefined;
    readonly " $fragmentRefs": FragmentRefs<"EventScreenPresentations_event">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EventScreenPresentations_event",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PresentationsConnection",
      "kind": "LinkedField",
      "name": "presentations",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PresentationsEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Presentation",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "rowId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "prettyUrl",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "title",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "description",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "presenterFirstName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "presenterLastName",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "concreteType": "User",
                  "kind": "LinkedField",
                  "name": "presenter",
                  "plural": false,
                  "selections": [
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "firstName",
                      "storageKey": null
                    },
                    {
                      "alias": null,
                      "args": null,
                      "kind": "ScalarField",
                      "name": "lastName",
                      "storageKey": null
                    },
                    {
                      "args": [
                        {
                          "kind": "Literal",
                          "name": "size",
                          "value": 96
                        }
                      ],
                      "kind": "FragmentSpread",
                      "name": "UserPrimaryPhotoNew_user"
                    }
                  ],
                  "storageKey": null
                }
              ],
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "cursor",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Event",
  "abstractKey": null
};
(node as any).hash = '96ff68fd078d9415b341a0bae0a2caae';
export default node;
